import { render, staticRenderFns } from "./AppHeaderSpMenu.vue?vue&type=template&id=485c8016&scoped=true"
import script from "./AppHeaderSpMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppHeaderSpMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppHeaderSpMenu.vue?vue&type=style&index=0&id=485c8016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485c8016",
  null
  
)

export default component.exports